
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImmovableSecurityFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImmovableSecurity"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"address"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"city"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"state"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"country"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pincode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"propertyType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ownedBy"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plotArea"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"constructionArea"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"marketValue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"chargeNature"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":209}};
    doc.loc.source = {"body":"fragment ImmovableSecurityFields on ImmovableSecurity {\n  id\n  type\n  address\n  city\n  state\n  country\n  pincode\n  propertyType\n  ownedBy\n  plotArea\n  constructionArea\n  marketValue\n  product\n  chargeNature\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    



//////////////////
// WEBPACK FOOTER
// ./src/graphql/fragments/ImmovableSecurityFragment.graphql
// module id = 520
// module chunks = 0